export default __webpack_public_path__ + "static/media/thumb-Nacic-Clock-3.2293eaaa.png";